import { Controller } from "@hotwired/stimulus"

const SVG_NAMESPACE = "http://www.w3.org/2000/svg"

export function showFlash(message, type) {
  const container = document.getElementById("flash_container") || document.getElementById("flash")
  if (!container) return

  const success = type === "success"
  const flash = document.createElement("div")
  flash.className = `fixed z-50 w-auto max-w-sm sm:max-w-md lg:max-w-lg flash-message ${success ? "flash-success" : "flash-error"}`
  flash.style.cssText = "top: 5rem; left: 50%; transform: translateX(-50%); margin-left: 0.5rem; width: calc(100vw - 3rem);"
  flash.setAttribute("role", "alert")
  flash.setAttribute("data-controller", "flash")

  const panel = document.createElement("div")
  panel.className = "bg-white rounded-xl shadow-lg border border-gray-200 p-4"

  const row = document.createElement("div")
  row.className = "flex items-center justify-between"

  const content = document.createElement("div")
  content.className = "flex items-start flex-1"
  content.append(buildIcon(success))

  const text = document.createElement("p")
  text.className = "text-sm text-gray-900"
  text.textContent = message
  content.append(text)

  const close = document.createElement("button")
  close.type = "button"
  close.className = "ml-4 inline-flex items-center px-3 py-1 text-xs font-medium text-white bg-gray-800 hover:bg-gray-900 rounded-md transition-colors cursor-pointer"
  close.setAttribute("data-action", "flash#remove")
  close.textContent = "Uždaryti"

  row.append(content, close)
  panel.append(row)
  flash.append(panel)
  container.replaceChildren(flash)
}

function buildIcon(success) {
  const icon = document.createElementNS(SVG_NAMESPACE, "svg")
  icon.setAttribute("class", `w-5 h-5 ${success ? "text-green-600" : "text-red-600"} mr-3 flex-shrink-0`)
  icon.setAttribute("fill", "none")
  icon.setAttribute("stroke", "currentColor")
  icon.setAttribute("viewBox", "0 0 24 24")

  const path = document.createElementNS(SVG_NAMESPACE, "path")
  path.setAttribute("stroke-linecap", "round")
  path.setAttribute("stroke-linejoin", "round")
  path.setAttribute("stroke-width", "2")
  path.setAttribute("d", success
    ? "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    : "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z")
  icon.append(path)

  return icon
}

export default class extends Controller {
  remove() {
    this.element.remove()
  }
}
